/**
 * Parse JSON from local-storage safely. Corrupt or missing values return fallback.
 */
export default function safeParse(value, fallback) {
  if (value == null || value === 'undefined') {
    return fallback
  }
  try {
    const parsed = typeof value === 'string' ? JSON.parse(value) : value
    return parsed == null ? fallback : parsed
  } catch (e) {
    return fallback
  }
}
